export class GeneralFieldsUtil {
	static phoneRegexValidationWithMask() {
		return /^\(\d{2}\) (9\d{4}|[2-5]\d{3})-\d{4}$/;
	}

	static emailRegexValidation() {
		return /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
	}
}
